<template>
  <div>
    <v-card-text class="pa-1 mt-0 material-table">
      <v-progress-linear rounded v-if="loadingProducts" height="6" class="mt-0 mb-1" indeterminate color="primary"></v-progress-linear>
      <v-form ref="materialForm">
        <v-simple-table dense class="bordered--table materials pa-1">
          <template v-slot:default>
            <thead>
              <tr>
                <th width="10%">
                  {{ $t('message.orders.productNo') }}
                </th>
                <th width="20%">
                  {{ $t('message.mailConfiguration.name') }}
                </th>
                 <th width="4%">
                  {{ $t('message.product.unit') }}
                </th>
                <th width="5%">{{ $t('message.whOrder.orderQty') }}</th>
                <th width="5%">{{ $t('message.orders.pQty') }}</th>
                <th width="8%">
                  {{ $t('message.layout.warehouse') }}
                  <v-progress-circular v-if="loadingWarehouse" indeterminate color="primary"></v-progress-circular>
                </th>
                <th width="8%">
                  {{ $t('message.stock.location') }}
                  <v-progress-circular v-if="loadingLocations" indeterminate color="primary"></v-progress-circular>
                </th>
                <th width="9%">
                  {{ $t('message.stock.batchOrWin') }}
                  <v-progress-circular v-if="loadingWIN" indeterminate color="primary"></v-progress-circular>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in listOfMaterials">
                <template v-if="!item.orderindex">
                  <tr :key="index">
                    <td class="pa-0" :style="{ 'background-color': (item.product_stockitem ? '#00800026' : '#450eec26') }">
                      <v-text-field :readonly="editDisabled" v-model="item.number" outlined dense hide-details></v-text-field>
                    </td>
                    <td class="pa-0" :style="{ 'background-color': (item.product_stockitem ? '#00800026' : '#450eec26') }">
                      <v-text-field :readonly="editDisabled" :rules="item.producttext ? $_maxCharValidation(80) : []" v-model="item.producttext" outlined dense hide-details></v-text-field>
                    </td>
                    <td class="pa-0">
                      <v-select autocomplete="off" :readonly="editDisabled"
                        v-model="item.unitid" :items="listOfUnits" item-text="name" item-value="id"
                        hide-details full-width outlined dense></v-select>
                    </td>
                    <td class="pa-0 text-right">
                      <template v-if="item.olditem.isapproved || item.olditem.pickedqty && item.olditem.pickedqty === item.olditem.qty">
                        <span class="pa-1">{{ item.qty }}</span>
                      </template>
                      <v-text-field class="text-right-align" v-else dense outlined :rules="$_requiredValidation" hide-details @change="setQtyToInvoiceQty(index, 'qty', 'invoiceqty')" :readonly="editDisabled" v-model="item.qty"></v-text-field>
                    </td>
                    <td class="pa-0 text-right">
                      <template v-if="item.olditem.isapproved || item.olditem.pickedqty">
                        <span class="pa-1">{{ item.pickedqty }}</span>
                      </template>
                      <v-text-field class="text-right-align" v-else dense outlined hide-details :readonly="editDisabled" v-model="item.pickedqty" @keyup="!item.olditem.pickedqty ? validateQty(index) : checkPickedQty(index)" @change="setQtyToInvoiceQty(index, 'pickedqty', 'invoiceqty')"></v-text-field>
                    </td>
                    <td class="pa-0">
                      <template v-if="item.olditem.warehouseid && !item.isstockedit">
                        <span class="pa-1">{{ item.warehouse_name }}</span>
                      </template>
                      <v-autocomplete autocomplete="off" v-else :readonly="editDisabled"
                        v-model="item.warehouseid" :items="item.warehouses" item-text="warehouse_name" item-value="warehouse_id"
                        hide-details full-width outlined dense @change="getListOfLocations(index)" :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                    </td>
                    <td class="pa-0">
                      <template v-if="item.olditem.locationid && item.olditem.pickedqty && !item.isstockedit">
                        <span class="pa-1">{{ item.warehouselocation_name }}</span>
                      </template>
                      <v-autocomplete autocomplete="off" v-else :readonly="editDisabled"
                        v-model="item.locationid" :items="item.locations" item-text="location_name" item-value="locationid"
                        :rules="item.product_type === 'product' ? (item.pickedqty ? $_requiredValidation : []) : []"
                        hide-details full-width outlined dense @change="getListOfWINNumbers(index)" :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                    </td>
                    <td class="pa-1">
                      <template v-if="item.olditem.pickedqty && item.olditem.batchnumber && !item.isstockedit">
                        <v-row>
                          <v-col cols="10">
                            <span class="pa-1">
                              {{ item.batchnumber }}
                            </span>
                          </v-col>
                          <v-col cols="2" class="pl-1 pr-1" @click="enableEditStock(index)">
                            <v-icon>mdi-lead-pencil</v-icon>
                          </v-col>
                        </v-row>
                      </template>
                      <template v-else-if="item.isbatch">
                        <v-row>
                          <v-col cols="10" class="pt-0 pb-0">
                            <v-autocomplete autocomplete="off" :readonly="editDisabled"
                              :rules="item.pickedqty ? $_requiredValidation: []"
                              v-model="item.batchnumber" @change="checkBatchNumberWithQty(index)" :items="item.batchnumbers"
                              item-text="batchnumber_ref" item-value="batchnumber"
                              hide-details full-width outlined dense :placeholder="$t('message.common.typeHere')">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="2" class="pa-0" @click="saveEditedWIN(item, index)">
                            <v-icon v-if="item.isstockedit">mdi-content-save</v-icon>
                          </v-col>
                        </v-row>
                      </template>
                    </td>
                  </tr>
                  <tr :key="`${index}_comments`" v-if="!item.is_parent_comments">
                    <td colspan="8" class="pa-1">
                      <v-textarea rows="1" :readonly="editDisabled" auto-grow hide-details dense outlined @change="assignComments(index)" v-model="item.comments"></v-textarea>
                    </td>
                  </tr>
                </template>
                <template v-else-if="item.orderindex">
                  <tr :key="index">
                    <td class="pa-1" colspan="4"></td>
                    <td class="pa-0 text-right">
                      <template v-if="item.olditem.isapproved || item.olditem.pickedqty">
                        <span class="pa-1">{{ item.pickedqty }}</span>
                      </template>
                      <v-text-field class="text-right-align" v-else dense outlined hide-details :readonly="editDisabled" v-model="item.pickedqty" @keyup="!item.olditem.pickedqty ? validateQty(index) : checkPickedQty(index)" @change="setQtyToInvoiceQty(index, 'pickedqty', 'invoiceqty')"></v-text-field>
                    </td>
                    <td class="pa-0">
                      <template v-if="item.olditem.warehouseid && !item.isstockedit">
                        <span class="pa-1">{{ item.warehouse_name }}</span>
                      </template>
                      <v-autocomplete autocomplete="off" v-else :readonly="editDisabled"
                        v-model="item.warehouseid" :items="item.warehouses" item-text="warehouse_name" item-value="warehouse_id"
                        hide-details full-width outlined dense @change="getListOfLocations(index)" :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                    </td>
                    <td class="pa-0">
                      <template v-if="item.olditem.locationid && item.olditem.pickedqty && !item.isstockedit">
                        <span class="pa-1">{{ item.warehouselocation_name }}</span>
                      </template>
                      <v-autocomplete autocomplete="off" v-else :readonly="editDisabled"
                        v-model="item.locationid" :items="item.locations" item-text="location_name" item-value="locationid"
                        :rules="item.product_type === 'product' ? (item.pickedqty ? $_requiredValidation : []) : []"
                        hide-details full-width outlined dense @change="getListOfWINNumbers(index)" :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                    </td>
                    <td class="pa-0">
                      <template v-if="item.olditem.pickedqty && !item.isstockedit">
                        <v-row>
                          <v-col cols="10">
                            <span class="pa-1">
                              {{ item.batchnumber }}
                            </span>
                          </v-col>
                          <v-col cols="2" class="pl-1 pr-1" @click="enableEditStock(index)">
                            <v-icon>mdi-lead-pencil</v-icon>
                          </v-col>
                        </v-row>
                      </template>
                      <template v-else-if="item.isbatch">
                        <v-row>
                          <v-col cols="10" class="pt-0 pb-0">
                            <v-autocomplete autocomplete="off" :readonly="editDisabled"
                              :rules="item.pickedqty ? $_requiredValidation: []"
                              v-model="item.batchnumber" @change="checkBatchNumberWithQty(index)" :items="item.batchnumbers"
                              item-text="batchnumber_ref" item-value="batchnumber"
                              hide-details full-width outlined dense :placeholder="$t('message.common.typeHere')">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="2" class="pa-0" @click="saveEditedWIN(item, index)">
                            <v-icon v-if="item.isstockedit">mdi-content-save</v-icon>
                          </v-col>
                        </v-row>
                      </template>
                    </td>
                  </tr>
                  <tr :key="`${index}_comments`" :style="{'background-color': item.color}" v-if="item.is_last_split">
                    <td colspan="8" class="pa-1">
                      <v-textarea rows="1" :readonly="editDisabled || item.olditem.isapproved" auto-grow hide-details dense outlined @change="changesMade" v-model="item.comments"></v-textarea>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </v-form>
    </v-card-text>
    <v-card-actions>
      {{ $t('message.orders.lastUpdated') }}: {{ lastUpdated }}
    </v-card-actions>
    <v-divider></v-divider>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: ['orderModel'],
  data () {
    return {
      listOfMaterials: [],
      loadingLocations: false,
      loadingWarehouse: false,
      loadingProducts: false,
      orderId: this.$route.params.order_id,
      saveLoading: false,
      isAllSelected: false,
      orderInfo: {
        state: ''
      },
      lastUpdated: '',
      loadingWIN: false
    }
  },
  computed: {
    ...mapState(['listOfUnits']),
    editDisabled () {
      return this.orderModel.state === 'closed'
    }
  },
  created () {
    this.$store.dispatch('getUnits')
  },
  mounted () {
    if (this.orderId) {
      this.getOrderMaterials()
    }
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === 'ordermaterials') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getOrderMaterials()
      }
    })
  },
  methods: {
    async getOrderMaterials () {
      this.loadingProducts = true
      this.$_executeApi('get', `ordermaterials/get_materials_list/${this.orderId}`)
        .then(async (response) => {
          const { materials, warehouseview, locationview, batchnumberview } = response.data
          const transformData = { number: { list: ['qty', 'pickedqty', 'invoiceqty', 'price', 'costprice', 'discount', 'total', 'dg'], format: 'replaceDotWithComma' } }
          const model = this.$_formatListModel(materials, transformData)
          let isAlignIndex = false
          for (let i = 0; i < model.length; i++) {
            if (!isAlignIndex) isAlignIndex = model[i].alignindex === null
            model[i].index = i
            model[i].olditem = this.$formatter.cloneVariable(model[i])
            model[i].isbatch = model[i].product_batchrequired || model[i].is_generate_win
            if (model[i].productid) {
              this.loadingWarehouse = true
              const warehouses = warehouseview.filter(x => x.warehouse_id && x.productid === model[i].productid && x.onstock > 0) // await this.getWarehouseStockHandler(model[i].productid)
              model[i].warehouses = warehouses
              this.loadingWarehouse = false
            }
            if (model[i].warehouseid) {
              this.loadingLocations = true
              const locations = locationview.filter(x => x.productid === model[i].productid && x.on_stock > 0) // await this.getStockHandler(model[i].warehouseid, model[i].productid)
              model[i].locations = locations
              if (model[i].locationid) {
                const batchnumbers = batchnumberview.filter(x => x.locationid === model[i].locationid && x.productid === model[i].productid) // await this.getBatchNumbersHandler(model[i].productid, model[i].locationid)
                model[i].batchnumbers = batchnumbers
              }
              this.loadingLocations = false
            }
            model[i].cloneComments = model[i].comments
          }
          let user = ''
          if (model[0]) {
            user = model[0].updatedby === -100 ? 'SuperAdmin' : `${model[0].user_name || ''}`
          }
          this.lastUpdated = `${(model[0] && model[0].updatedon) ? `${this.$formatter.formatDate(model[0].updatedon, 'DD.MM.YYYY HH:mm:ss', 'DD.MM.YYYY HH:mm:ss')}, ${user || ''}` : ''}`
          // splitting logic with extra flags
          const getPackageIds = model.filter(x => x.ispackage).map(x => x.id)
          const products = []
          getPackageIds.map(x => {
            // splitting logic inside package content and sort them
            var getProducts = model.filter(y => y.packageid === x && !y.orderindex)
            var getSplitChildProducts = model
            var getParent = model.find(y => y.id === x)
            products.push(getParent)
            let getCount = -1
            const childRefs = []
            getSplitChildProducts.map((y) => {
              const getParentIndex = getProducts.findIndex(j => j.id === y.orderindex)
              if (getParentIndex > -1) {
                if (!childRefs.includes(getProducts[getParentIndex].id)) {
                  getCount = getParentIndex + 1
                } else getCount++
                childRefs.push(y.orderindex)
                getProducts.splice(getCount, 0, y)
              }
            })
            products.push(...getProducts)
          })
          const individualProducts = model.filter(x => !x.ispackage && !x.packageid)
          products.push(...individualProducts)

          products.map(z => {
            if (z.orderindex) {
              const getParent = products.find(x => x.id === z.orderindex)
              const getParentIndex = products.findIndex(x => x.id === z.orderindex)
              if (getParentIndex > -1) products[getParentIndex].is_parent_comments = true
              let lastSplitId = 0
              if (getParent) {
                const getChilds = products.filter(x => x.orderindex === getParent.id)
                getChilds.map((y, index) => {
                  if ((getChilds.length - 1) === index) lastSplitId = y.id
                  return y
                })
              }
              const getSplittedLastIndex = products.findIndex(x => x.id === lastSplitId)
              if (getSplittedLastIndex > -1) products[getSplittedLastIndex].is_last_split = true
            }
          })
          let totalProducts = products
          if (!isAlignIndex) totalProducts = products.sort((a, b) => (a.index > b.index) ? 1 : ((b.index > a.index) ? -1 : 0))
          this.listOfMaterials = totalProducts
        })
        .finally(() => {
          this.loadingProducts = false
        })
    },
    saveMaterials (isClose) {
      return new Promise((resolve, reject) => {
        if (this.$refs.materialForm.validate()) {
          this.saveLoading = true
          const list = this.$formatter.cloneVariable(this.listOfMaterials)
          list.map(x => {
            if (!x.olditem.isapproved) x.isapproved = false
            x.qty = this.$formatter.replaceCommaWithDot(x.qty)
            x.pickedqty = this.$formatter.replaceCommaWithDot(x.pickedqty)
            if (!x.pickedqty) {
              x.warehouseid = null
              x.locationid = null
              x.batchnumber = null
            }
            x.invoiceqty = this.$formatter.replaceCommaWithDot(x.invoiceqty)
            x.price = this.$formatter.replaceCommaWithDot(x.price)
            x.costprice = this.$formatter.replaceCommaWithDot(x.costprice)
            x.discount = this.$formatter.replaceCommaWithDot(x.discount)
            x.total = this.$formatter.replaceCommaWithDot(x.total)
            x.dg = this.$formatter.replaceCommaWithDot(x.dg)
            return x
          })
          this.$_executeApi('post', `ordermaterials/update_materials/${this.orderId}`, list)
            .then((response) => {
              this.$store.commit('isChangesMade', false)
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
              this.saveLoading = false
              if (isClose) this.$router.push('/orders')
              else {
                this.getOrderMaterials()
              }
            })
            .finally(() => {
              resolve()
            })
        } else {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
          reject(new Error('Validation issue'))
        }
      })
    },
    async getListOfWINNumbers (index) {
      this.changesMade()
      const getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getObj) {
        if (getObj.locations) {
          const currentLocation = getObj.locations.find(x => x.locationid === getObj.locationid)
          let onStockValue = 0
          if (currentLocation.on_stock) {
            onStockValue = currentLocation.on_stock
          } else {
            onStockValue = currentLocation.onstock
          }
          const onStock = this.$formatter.replaceCommaWithDot(onStockValue)
          const pickedQty = this.$formatter.replaceCommaWithDot(getObj.pickedqty)
          if (currentLocation && +onStock < +pickedQty) {
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
            const newObj = { ...getObj, pickedqty: '' }
            this.$set(this.listOfMaterials, index, newObj)
          }
        }
        if (getObj.isbatch) {
          const batchNumbers = await this.getBatchNumbersHandler(getObj.productid, getObj.locationid)
          getObj.batchnumber = ''
          getObj.batchnumbers = batchNumbers
          setTimeout(() => {
            this.$set(this.listOfMaterials, index, getObj)
          })
        }
      }
    },
    getBatchNumbersHandler (productid, locationid) {
      return new Promise((resolve, reject) => {
        this.loadingWIN = true
        this.$_executeApi('get', `/warehouseorderitems/get_batchnumbers_by_location?product_id=${productid}&location_id=${locationid}`)
          .then((result) => {
            let model = result.data
            const transformData = { number: { list: ['onstock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.batchnumber_ref = ''
              x.batchnumber_ref = `${x.batchnumber} ${x.is_defect_batch ? '(B)' : ''} (${x.onstock})`
              return x
            })
            this.loadingWIN = false
            resolve(model)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    async getListOfLocations (index) {
      this.changesMade()
      const getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getObj) {
        this.loadingLocations = true
        const locations = await this.getStockHandler(getObj.warehouseid, getObj.productid)
        getObj.locationid = 0
        getObj.locations = locations
        getObj.batchnumber = ''
        getObj.batchnumbers = []
        this.loadingLocations = false
        setTimeout(() => {
          this.$set(this.listOfMaterials, index, getObj)
        })
      }
    },
    getWarehouseStockHandler (productid) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `/stocks/get_product_stock_count?product_id=${productid}`)
          .then((result) => {
            let model = result.data
            const transformData = { number: { list: ['onstock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.warehouse_name = `${x.warehouse_name} ${x.onstock ? `(${x.onstock})` : ''}`
              x.id = x.warehouseid
              return x
            })
            resolve(model)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getStockHandler (warehouseId, productid) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `/stocks/get_product_by_warehouse?product_id=${productid}&warehouse_id=${warehouseId}`)
          .then((result) => {
            let model = result.data
            const transformData = { number: { list: ['onstock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.location_name = `${x.location_name} (${x.onstock})`
              x.id = x.locationid
              return x
            })
            resolve(model)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    checkBatchNumberWithQty (index) {
      const getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getObj) {
        const stockObj = getObj.batchnumbers ? getObj.batchnumbers.find(x => x.batchnumber === getObj.batchnumber) : null
        if (stockObj) {
          const stockValue = parseFloat(this.$formatter.replaceCommaWithDot(stockObj.onstock || 0))
          const pickedqty = parseFloat(this.$formatter.replaceCommaWithDot(getObj.pickedqty || 0))
          if (stockValue < pickedqty) {
            getObj.pickedqty = ''
            this.$set(this.listOfMaterials, index, getObj)
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
          }
        }
        getObj.comments = getObj.cloneComments + ' ' + getObj.batchnumber
        this.$set(this.listOfMaterials, index, getObj)
        // update comments when selecting/changing the WIN number
        // const winNumbers = []
        // this.listOfMaterials
        //   .filter(x => x.id === getObj.id || x.orderindex === getObj.id || x.id === getObj.orderindex)
        //   .map(x => x.batchnumbers.map(y => winNumbers.push(y.batchnumber)))
        // winNumbers.forEach(number => {
        //   if (!getObj.cloneComments.includes(number)) return false
        //   getObj.cloneComments = getObj.cloneComments.replace(number, '')
        //   console.log(getObj.cloneComments)
        // })
        // getObj.comments = getObj.cloneComments + ' ' + getObj.batchnumber
        // this.$set(this.listOfMaterials, index, getObj)

        // const getParentIndex = this.listOfMaterials.findLastIndex(x => x.id === getObj.orderindex)
        // console.log(getParentIndex)
        // const getParentModel = this.$formatter.cloneVariable(this.listOfMaterials[getParentIndex])
        // getParentModel.comments = getObj.comments
        // this.$set(this.listOfMaterials, getParentIndex, getParentModel)
      }
    },
    assignComments (index) {
      const getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getObj) {
        getObj.cloneComments = getObj.comments
        this.$set(this.listOfMaterials, index, getObj)
      }
    },
    checkPickedQty (index) {
      const getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getObj) {
        const qty = parseFloat(this.$formatter.replaceCommaWithDot(getObj.qty || 0))
        const pQty = parseFloat(this.$formatter.replaceCommaWithDot(getObj.pickedqty || 0))
        if (qty < pQty) {
          getObj.qty = this.$formatter.replaceDotWithComma(pQty)
          this.$set(this.listOfMaterials, index, getObj)
        }
      }
    },
    validateQty (index) {
      const getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getObj) {
        const getLocationId = getObj.locationid
        const stockObj = getObj.locations ? getObj.locations.find(x => x.locationid === getLocationId) : null
        const qty = this.listOfMaterials[index].qty ? parseFloat(this.$formatter.replaceCommaWithDot(this.listOfMaterials[index].qty || 0)) : 0
        const pQty = parseFloat(this.$formatter.replaceCommaWithDot(this.listOfMaterials[index].pickedqty || 0))
        if (stockObj) {
          const stockValue = parseFloat(this.$formatter.replaceCommaWithDot(stockObj.onstock || 0))
          if (stockValue < pQty) {
            getObj.pickedqty = ''
            this.$set(this.listOfMaterials, index, getObj)
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
            return
          }
        }
        if (qty < pQty) {
          getObj.pickedqty = ''
          this.$set(this.listOfMaterials, index, getObj)
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.orderedQtyLessMsg') })
          return
        }
        // Check with batchnumbers qty
        const winObj = getObj.batchnumbers ? getObj.batchnumbers.find(x => x.batchnumber === getObj.batchnumber) : null
        if (winObj) {
          const stockValue = parseFloat(this.$formatter.replaceCommaWithDot(winObj.onstock || 0))
          const pickedqty = parseFloat(this.$formatter.replaceCommaWithDot(getObj.pickedqty || 0))
          if (stockValue < pickedqty) {
            getObj.pickedqty = ''
            this.$set(this.listOfMaterials, index, getObj)
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
          }
        }
      }
    },
    removeRowHandler (index, id) {
      if (this.listOfMaterials.length >= 1) {
        if (this.listOfMaterials[index].id) {
          const payload = { ids: [id], url: 'ordermaterials/delete_multiple', module: 'ordermaterials' }
          this.$store.commit('showDeleteDialog', payload)
        } else this.listOfMaterials.splice(index, 1)
      }
    },
    setQtyToInvoiceQty (index, field, mapField) {
      const item = this.$formatter.cloneVariable(this.listOfMaterials[index])
      item[mapField] = item[field] ? item[field] : ''
      this.$set(this.listOfMaterials, index, item)
    },
    downloadOrder () {
      this.$parent.downloadOrder()
    },
    shareOrder () {
      this.$parent.sendReport()
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    },
    enableEditStock (index) {
      const getModelObj = this.listOfMaterials[index]
      if (!getModelObj) return false
      this.$set(this.listOfMaterials, index, { ...getModelObj, isstockedit: true })
    },
    saveEditedWIN (model, index) {
      this.loadingProducts = true
      this.$_executeApi('post', `/ordermaterials/update_win_number/${model.id}?newWinNumber=${model.batchnumber}&warehouse_id=${model.warehouseid}&location_id=${model.locationid}`)
        .then((result) => {
          if (result.data) {
            const modelObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
            modelObj.isstockedit = false
            this.$set(this.listOfMaterials, index, modelObj)
            this.loadingProducts = false
          }
        })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('canelLoading')
  }
}
</script>
<style>
.material-table .v-data-table th {
  padding: 0 9px !important;
}
.materials .v-data-table__wrapper {
  overflow-x: hidden;
}
.materials .v-text-field.v-text-field--enclosed .v-text-field__details, .materials .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  padding: 0 4px !important;
}
.text-right-align input, .text-right-align select {
  text-align: right !important;
}
.material-table .v-input {
  font-size: 14px !important;
}
.material-table .v-textarea.v-text-field--enclosed.v-text-field--outlined textarea {
  margin-top: 2px !important;
}
.material-table .v-textarea textarea {
  padding: 2px 0 1px !important;
}
.material-table .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 30px !important;
}
.material-table .v-select__slot {
  height: 30px !important;
}
.material-table .v-input__append-inner {
  margin-top: 4px !important;
}
.material-table .v-btn--fab.v-size--small {
  height: 33px !important
}
</style>
